import { createReducer } from "./functions";

import { NETWORKS_SET_LIST } from '../types';

const initialState = {
  networksList: [],
  page: 0,
  pages: 0,
  pageSize: 10
}

const setNetworksList = {
  [NETWORKS_SET_LIST]: (state, action) => {
    const page = action.payload.hasOwnProperty("page")
    ? action.payload.page
    : state.page;
    const pages = action.payload.hasOwnProperty("pages")
      ? action.payload.pages
      : state.pages;
    let hasNext = true;

    if (page === 0 || page === pages)
      hasNext = false;
    return { ...state, networksList: action.payload.docs, page, pages, hasNext };
  }
}
const networksReducer = createReducer(initialState, {
  ...setNetworksList
})

export default networksReducer;


// WEBPACK FOOTER //
// src/redux/reducers/networksReducer.js